module.exports = __webpack_public_path__ + "media/react-view-today@lg-8a97debb011eb7d5fbbd871767657740.jpg";